(function ($) {
  "use strict";
  jQuery(document).ready(function(){
    /*--
Menu Sticky
-----------------------------------*/
    var windows = $(window);
    var sticky = $('.header-area');
    windows.on('scroll', function() {
      var scroll = windows.scrollTop();
      if (scroll < 100) {
        sticky.removeClass('is-sticky');
      }else{
        sticky.addClass('is-sticky');
      }
    });
    document.onkeydown = function(e) {
      if(event.keyCode == 123) {
        return false;
      }
      if(e.ctrlKey && e.shiftKey && e.keyCode == 'I'.charCodeAt(0)) {
        return false;
      }
      if(e.ctrlKey && e.shiftKey && e.keyCode == 'C'.charCodeAt(0)) {
        return false;
      }
      if(e.ctrlKey && e.shiftKey && e.keyCode == 'J'.charCodeAt(0)) {
        return false;
      }
      if(e.ctrlKey && e.keyCode == 'U'.charCodeAt(0)) {
        return false;
      }
    }

   

      $("button.navbar-toggler").click(function(){
        $(".main-menu-area").addClass("active");
        $(".mm-fullscreen-bg").addClass("active");
        $("body").addClass("hidden");
      });
      $(".close-box").click(function(){
        $(".main-menu-area").removeClass("active");
        $(".mm-fullscreen-bg").removeClass("active");
        $("body").removeClass("hidden");
      });
      $(".mm-fullscreen-bg").click(function(){
        $(".main-menu-area").removeClass("active");
        $(".mm-fullscreen-bg").removeClass("active");
        $("body").removeClass("hidden");
        $(".filter-sidebar").removeClass("active");
      });

      // $(".shopping-cart a.cart-count").click(function(){
      //   $(".mini-cart").addClass("show");
      //   $(".mm-fullscreen-bg").addClass("active");
      //   $("body").addClass("hidden");
      // });
      // $(".shopping-cart-close i").click(function(){
      //   $(".mini-cart").removeClass("show");
      //   $(".mm-fullscreen-bg").removeClass("active");
      //   $("body").removeClass("hidden");
      // });
      // $(".mm-fullscreen-bg").click(function(){
      //   $(".mini-cart").removeClass("show");
      //   $(".mm-fullscreen-bg").removeClass("active");
      // });
    // filter button js
    $("button.filter-button").on('click', function() {
      $(".filter-sidebar").addClass("active");
      $(".mm-fullscreen-bg").addClass("active");
    });
    $("button.close-filter-sidebar").on('click', function() {
      $(".filter-sidebar").removeClass("active");
      $(".mm-fullscreen-bg").removeClass("active");
    });

      $('[data-toggle="tooltip"]').tooltip();



    /* ===================================
masonry
====================================== */

    $('.grid').imagesLoaded(function () {
      $('.grid').isotope({
        itemSelector: 'li',
        layoutMode: 'masonry'
      });
    });

    $(window).scroll(function(){
      if ($(this).scrollTop() > 1000) {
        $('#top').fadeIn();
      } else {
        $('#top').fadeOut();
      }
    });
    $('#top').click(function(){
      $("html, body").animate({ scrollTop: 0 }, 600);
      return false;
    });
  });
})(jQuery);